export const Messages = {
  LoginExpiredMessage:
    'O seu login expirou. Por favor, informe novamente as suas credenciais.',
  InternalServerError:
    'Não conseguimos conectá-lo. Verifique a sua conexão com a internet.',

  RequiredChaveValidationMessage: '^Informe a chave de acesso.',

  RequiredCpfValidationMessage: '^Informe o seu CPF.',
  InvalidCpfValidationMessage: '^O cpf informado está incorreto.',

  RequiredBirthdateValidationMessage: '^Informe sua data de nascimento.',
  RequiredAditionalBirthdateValidationMessage: '^Informe a data de nascimento.',
  InvalidBirthdateValidationMessage:
    '^A data de nascimento informada está incorreta.',

  RequiredEmailValidationMessage: '^Informe o e-mail.',
  InvalidEmailValidationMessage: '^O e-mail informado está incorreto.',

  RequireCelValidationMessage: '^Informe o número do celular.',

  RequireGenderValidationMessage: '^Informe o sexo.',

  RequireNameValidationMessage: '^Informe o nome.',
  RequiredNameFullValidationRequiredMessage: '^Informe o nome completo.',
  RequiredMaritalStatusValidationMessage: '^Informe o estado civil.',
  MothernameTooLongValidationRequiredMessage:
    '^Nome completo da sua mãe não pode conter mais que 100 caracteres.',
  RequiredMothernameValidationRequiredMessage: '^Informe o nome da mãe.',
  RequiredBirthstateRequiredMessage: '^Informe o estado de nascimento.',
  RequiredBirthcityRequiredMessage: '^Informe a cidade de nascimento.',

  RequiredHomeaddressValidationMessage: '^Informe o endereço.',
  RequiredCepaddressValidationMessage: '^Informe o CEP.',
  RequiredNumberaddressValidationMessage: '^Informe o número.',
  RequiredNeighborhoodaddressValidationMessage: '^Informe o bairro.',
  RequiredUfaddressValidationMessage: '^Informe a UF.',
  RequiredCityaddressValidationMessage: '^Informe a cidade.',

  RequiredNationalityDocumentValidationMessage: '^Informe a nacionalidade.',
  RequiredRgDocumentValidationMessage: '^Informe o RG.',
  RequiredRneDocumentValidationMessage: '^Informe o RNE/CRNM.',
  InvalidRgDocumentValidationMessage: '^RG inválido.',
  InvalidRneDocumentValidationMessage: '^RNE/CRNM inválido.',
  RequiredUfDocumentValidationMessage: '^Informe a UF.',
  RequiredEmitterDocumentValidationMessage: '^Informe o orgão emissor.',
  RequiredIssueDateDocumentValidationMessage: '^Informe a data de emissão.',
  InvalidIssueDateDocumentValidationMessage:
    '^A data de emissão informada está incorreta.',

  RequiredTypeProfessionValidationMessage: '^Informe o tipo de profissão.',
  RequiredProfessionValidationMessage: '^Informe a profissão.',
  RequiredCompanyValidationMessage: '^Informe a empresa.',
  RequiredDateAdmissionValidationMessage: '^Informe a data de admissão.',
  InvalidAdmissionDateMessage: '^Data de admissão inválida.',
  LowestCurrentDateAdmissionValidationMessage:
    '^Data de admissão maior que a data atual.',
  LowestCurrentDateIssueValidationMessage:
    '^Data de emissão maior que a data atual.',

  RequiredMonthlyIncomeValidationMessage: '^Informe a renda mensal.',
  RequiredDddTelephoneValidationMessage: '^Informe o ddd.',
  RequiredTelephoneValidationMessage: '^Informe o telefone.',
  RequiredCelularValidationMessage: '^Informe o celular.',

  RequiredEmailConfirmacaoValidationMessage: '^Faltou confirmar o email.',
  InvalidEmailConfirmacaoValidationMessage: '^Os e-mails não estão iguais.',

  RequiredPoliticsValidationMessage: '^Aceite a política de privacidade.',

  RequiredEmbossingValidationMessage: '^Informe o nome impresso do cartão.',
  EmbossingValidationTooLong: '^O nome não pode ultrapassar 19 caracteres.',
  RequiredEmbossingFullValidationRequiredMessage:
    '^Informe sobrenome no nome impresso do cartão.',
  RequiredInvoiceDigitalFullValidationRequiredMessage:
    '^Informe se deseja fatura digital do cartão.',
  RequiredExpirationDayValidationRequiredMessage:
    '^Informe o dia de vencimento do cartão.',

  Under18YearsValidationMessage: '^É necessário ter mais de 18 anos.',
  Under16YearsValidationMessage: '^É necessário ter mais de 16 anos.',
  Over100YearsValidationMessage: '^É necessário ter menos de {year} anos.',
  NumberPhoneIncorrectMessage: '^Celular está incorreto.',
  TelephoneIncorrectMessage: '^Telefone fixo está incorreto.',

  NumberCodeValidationSmsRequired: 'Código de confirmação obrigatório.',
  NumberCodeValidationSmsInvalid: 'Código de confirmação incorreto.',
  RequiredAuthorizationTermsMessage:
    'É necessário aceitar o termo de autorização.',
  ErrorTryAgainMessage:
    'Ocorreu um erro inesperado, por gentileza acesse novamente o seu convite em alguns minutos.',
  RequiredRelationshipMessage: '^Informe o parentesco com o titular do cartão.',
};
